import(/* webpackMode: "eager" */ "/app/app/not-found.jsx");
